import React from 'react';
import PropTypes from 'prop-types';

function OptionsButton({ active, activeColor, color }) {
  return (
    <path
      d="M531.991 168.613H524.877C520.817 168.613 517.495 165.291 517.495 161.231V139.108C517.495 135.048 520.817 131.726 524.877 131.726H531.991C536.051 131.726 539.373 135.048 539.373 139.108V161.231C539.373 165.291 536.051 168.613 531.991 168.613Z"
      fill={active ? activeColor : color}
    />
  );
}

OptionsButton.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  color: PropTypes.string,
};

OptionsButton.defaultProps = {
  active: false,
  activeColor: '#FFFFFF',
  color: '#4F535F',
};

export default OptionsButton;
